export default __webpack_public_path__ + "static/media/main_5.d87089c9.jpeg";